// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementGetCanvasesForFilterResult = arrayOf(
  objectOf({
    id: string,
    value: string,
  })
);
